var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"overflow":"auto","border":"1px ridge blue"},attrs:{"type":"text/html","src":_vm.url,"width":"100%","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }